import { Routes } from '@angular/router';

import { MasterComponent } from './master.component';
import { MasterDetailComponent } from './master-detail.component';
import { MasterPopupComponent } from './master-dialog.component';
import { MasterDeletePopupComponent } from './master-delete-dialog.component';
import {UserRouteAccessService} from '../../shared/auth/user-route-access-service';
import {MasterReferentielComponent} from './master-referentiel.component';
import {MasterDetailReferentielComponent} from './master-detail-referentiel.component';


export const masterRoute: Routes = [
  {
    path: 'masters',
    component: MasterComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_MINISTRY', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR', 'ROLE_SCHOOL_ADMIN'],
        pageTitle: 'tmmsaisineApp.master.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'masters/:id',
    component: MasterDetailComponent,
    data: {
        authorities: ['ROLE_MINISTRY', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR', 'ROLE_SCHOOL_ADMIN'],
        pageTitle: 'tmmsaisineApp.master.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
        path: 'referentiel-masters/:id',
        component: MasterDetailReferentielComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'tmmsaisineApp.master.referentiel.title'
        },
        canActivate: [UserRouteAccessService]
  }, {
    path: 'referentiel-masters',
    component: MasterReferentielComponent,
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'tmmsaisineApp.master.referentiel.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const masterPopupRoute: Routes = [
  {
    path: 'masters-nouveau',
    component: MasterPopupComponent,
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'tmmsaisineApp.master.referentiel.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'masters/:id/edition',
    component: MasterPopupComponent,
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'tmmsaisineApp.master.referentiel.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'masters/:id/suppression',
    component: MasterDeletePopupComponent,
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'tmmsaisineApp.master.referentiel.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master.route.ts